import { render, staticRenderFns } from "./PremiumTrainingRecord.vue?vue&type=template&id=30dade3e&"
import script from "./PremiumTrainingRecord.vue?vue&type=script&lang=js&"
export * from "./PremiumTrainingRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports